import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { PanelLeftOpen, Search } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { AppLayoutContext } from '@/context/AppLayoutContext'
import { useSidebarModeStore } from '@/store/SidebarModeStore'

/**
 * Hidden sidebar (design 5c): a small floating pill at top left brings the
 * sidebar back or opens ⌘K. The left edge still peeks the full menu.
 */
export function HiddenSidebarPill() {
  const { t } = useTranslation('navigation')
  const layout = useContext(AppLayoutContext)
  const setHidden = useSidebarModeStore((s) => s.setHidden)

  return (
    <div className="absolute left-3 top-2.5 z-20 hidden items-center gap-0.5 rounded-full border bg-chrome/90 p-0.5 shadow-sm backdrop-blur desk:flex">
      <Button
        variant="ghost"
        size="icon"
        className="size-7 rounded-full"
        aria-label={t('sidebar.show')}
        title={t('sidebar.show')}
        onClick={() => setHidden(false)}
      >
        <PanelLeftOpen className="size-4" />
      </Button>
      <Button
        variant="ghost"
        className="h-7 gap-1.5 rounded-full px-2.5 text-xs text-muted-foreground"
        onClick={() => layout?.openSearch()}
      >
        <Search className="size-3.5" />
        {t('sidebar.search')}
        <kbd className="font-mono text-[10px]">⌘K</kbd>
      </Button>
    </div>
  )
}
